import {setIsLoading} from '../../../actions/loadingActions';
import {useDispatch} from 'react-redux';

let loadingCount = 0;

const useDispatchAction = () => {
	const dispatch = useDispatch();

	return (action, ignoreLoading = false) => {
		if (ignoreLoading) {
			return dispatch(action);
		}

		if (loadingCount === 0) {
			dispatch(setIsLoading(true));
		}
		++loadingCount;
		const promise = dispatch(action);
		promise.finally(() => {
			if (loadingCount > 0) {
				--loadingCount;
				if (loadingCount === 0) {
					dispatch(setIsLoading(false));
				}
			}
		});
		return promise;
	};
};

export {useDispatchAction};
